











































import { Component } from 'vue-property-decorator';

import Edit from '@/layouts/Edit';
import TitleReturn from '@/components/TitleReturn.vue';
import EditBlock from '@/views/CRUD/Edit.vue';
import CalendarRepository from '@/components/calendar/CalendarRepository.vue';
import CalendarAdmin from '@/components/calendar/CalendarAdmin.vue';

import DoctorsModule from '@/store/doctors';
import DoctorEntityModule from '@/store/doctors/entity';

import { editTabsNav } from "@/store/doctors/tabs";

import { SelectItem } from '@/components/select/types';

@Component({
    components: {
        TitleReturn,
        EditBlock,
        CalendarRepository,
        CalendarAdmin,
    },
})
export default class DoctorsScheduleEditPage extends Edit {
    tabsNav = editTabsNav
    clinics: SelectItem[] = [];
    hasCommonPractice = false;

    get doctorId() {
        return Number(this.$route.params.doctorsId);
    }
    
    get currentTab() {
        return editTabsNav.schedule.id;
    }
    
    returnBefore() {
        this.$router.push({name: 'doctors'});
    }

    async created() {
        this.titleEdit = DoctorsModule.pageSettings.titleEdit;

        const doctor = await DoctorEntityModule.getById(String(this.doctorId));
        const backendClinics = doctor?.clinics ?? []

        this.clinics = backendClinics.map(clinic => ({
            id: clinic.id,
            value: clinic.title,
        }));

        const hasCommonPracticeSpec = Object.values(doctor.specializations).find(specialization => specialization.isCommonPractice);
        if (hasCommonPracticeSpec) {
            this.hasCommonPractice = true;
        }
    }
}
